
export const layersMapserverComPopup = ['Articulação Sistemática', 'Aeroporto', 'Bases de Voo', 'RBMC'];
export const layerDatabaseComCustomPopup = ['Recobrimento Aerofotogramétrico', 'Perfilamento a LASER Aerotransportado', 'Classificação da Nuvem De Pontos'];
export const camposPopupLayersLinhas = ['faixas', 'flightline', 'be', 'bm', 'lote', 'status', 'empresa', 'dt_voo'];
export const camposPopupClassificacao = [
  'lote',
  'blocos',
  'be',
  'bm',
  'np',
  'npc',
  'status',
  'empresa',
  'area_km2',
  'descricao'
];

export const keyNamePopupDatabase = {
  "np": "np",
  "npc": "npc",
  "area_km2": "Área km²",
  "blocos": "Blocos",
  "empresa": "Empresa",
  "lote": "Lote",
  "status": "Status",
  "faixas": "Faixa",
  "flightline": "Faixa",
  "dt_voo": "Data de voo"
}

export const popupMapserverFormatters = {
  "Articulação Sistemática": (text) => {
    const mi = extractValue(text, "mi");
    const mi2 = extractValue(text, "mi_2");
    const lote = extractValue(text, "lote");
    const blocos = extractValue(text, "blocos");
    const area_km2 = extractValue(text, "area_km2_2");
    return `<b>Mi:</b> ${mi}<br>
            <b>Mi2:</b> ${mi2}<br>
            <b>Lote:</b> ${lote}<br>
            <b>Blocos:</b> ${blocos}<br>
            <b>Área KM²:</b> ${area_km2}<br>
            `;
  },
  "Bases de Voo": (text) => {
        console.log(text);

    const nome = extractValue(text, "name");
    const empresa = extractValue(text, "empresa");
    return `<b>Empresa:</b> ${empresa}<br><b>Nome:</b> ${nome}<br>`;
  },
  "Aeroporto": (text) => {
    const municipio = extractValue(text, "município");
    const nome = extractValue(text, "nome");
    return `<b>Nome:</b> ${nome}<br><b>Município:</b> ${municipio}<br><b>UF:</b> PR`;
  },
  "RBMC": (text) => {
    const nome = extractValue(text, "name");
    return `<b>Nome:</b> ${nome}<br>`;
  },
  "default": (text) => `<pre>${text}</pre>`
};


export function extractValue(text, key) {
  const regex = new RegExp(`${key}\\s*=\\s*'?(.+?)'?\\s*$`, 'im');
  const match = text.match(regex);
  return match ? match[1] : "N/A";
}
